<template>
    <div>
        <!-- Informar Valor -->
        <div class="modal fade" id="editarValorTotalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="valor_total !== null">
                    <div class="modal-header">
                        <h5 class="modal-title">Informar Valor Total</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input 
                            v-model="valor_total" 
                            label="Valor Total" 
                            type="money" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="atualizar()">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            valor_total: null,
            origem: null,
            campo_qtd: null,
            campo_unitario: null,
        }
    },

    components: {
        AzInput,
    },

    methods: {
        editar(origem, campo_qtd, campo_unitario) {
            this.valor_total = null;
            this.origem = origem;
            this.campo_qtd = campo_qtd;
            this.campo_unitario = campo_unitario;

            this.$nextTick(() => { 

                this.valor_total = _.get(origem, campo_qtd, 0) * _.get(origem, campo_unitario, 0);

                $('#editarValorTotalModal').modal('show');

            });
        },

        fechar_modal() {
            $('#editarValorTotalModal').modal('hide');
        },

        atualizar() {
            let qtd = _.get(this.origem, this.campo_qtd, 0);

            if ( !qtd ) { 
                qtd = 1;
            }

            this.$parent.excluindo = true;

            this.$nextTick(() => { 
                _.set(this.origem, this.campo_unitario, Math.round( ( this.valor_total / qtd ) * 100 ) / 100);
                this.fechar_modal();

                this.$parent.excluindo = false;
            });
        }
    }
}
</script>
